import { useABTestsContext } from '@helpers/context/ABTestsContext'

function useABtests() {
  return useABTestsContext()
}

export default useABtests
